module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "journey-sidebar",
    class: {
      collapsed: _vm.collapsed,
      peeking: _vm.collapsed && _vm.peeking
    },
    style: ((!_vm.collapsed || _vm.peeking) ? {
      width: _vm.width + 'px'
    } : null),
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "click": _vm.onPanelClick
    }
  }, [_c('div', {
    staticClass: "js-head"
  }, [(!_vm.collapsed || _vm.peeking) ? _c('span', {
    staticClass: "js-title"
  }, [_vm._v("Journey")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "js-toggle",
    attrs: {
      "title": _vm.collapsed ? 'Expand' : 'Collapse'
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "15 18 9 12 15 6"
    }
  })])])]), _vm._v(" "), (!_vm.collapsed || _vm.peeking) ? _c('div', {
    staticClass: "js-body"
  }, [_c('div', {
    staticClass: "js-dropdown",
    class: {
      open: _vm.ddOpen
    }
  }, [_c('button', {
    staticClass: "js-dd-btn",
    on: {
      "click": function($event) {
        _vm.ddOpen = !_vm.ddOpen
      }
    }
  }, [_c('span', {
    staticClass: "js-dd-current"
  }, [_vm._v(_vm._s(_vm.currentJourneyKey || 'No journey'))]), _vm._v(" "), (_vm.versions.length) ? _c('span', {
    staticClass: "js-dd-version"
  }, [_vm._v("v" + _vm._s(_vm.versions[0].versionNumber))]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "js-dd-caret",
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "6 9 12 15 18 9"
    }
  })])]), _vm._v(" "), (_vm.ddOpen) ? _c('div', {
    staticClass: "js-dd-menu"
  }, [_c('div', {
    staticClass: "js-dd-search"
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "7"
    }
  }), _c('path', {
    attrs: {
      "d": "m21 21-4.35-4.35"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ddFilter),
      expression: "ddFilter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search journeys..."
    },
    domProps: {
      "value": (_vm.ddFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ddFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "js-dd-list"
  }, [_vm._l((_vm.filteredKeys), function(k) {
    return _c('div', {
      key: k,
      staticClass: "js-dd-opt",
      class: {
        active: k === _vm.currentJourneyKey
      },
      on: {
        "click": function($event) {
          return _vm.selectJourney(k)
        }
      }
    }, [_c('span', {
      staticClass: "js-dd-opt-name"
    }, [_vm._v(_vm._s(k))]), _vm._v(" "), (k === _vm.currentJourneyKey) ? _c('svg', {
      staticClass: "js-dd-check",
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.5",
        "stroke-linecap": "round"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "20 6 9 17 4 12"
      }
    })]) : _vm._e()])
  }), _vm._v(" "), (!_vm.filteredKeys.length) ? _c('div', {
    staticClass: "js-dd-empty"
  }, [_vm._v("No matches")]) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "js-new-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('create-new')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "12",
      "y1": "5",
      "x2": "12",
      "y2": "19"
    }
  }), _c('line', {
    attrs: {
      "x1": "5",
      "y1": "12",
      "x2": "19",
      "y2": "12"
    }
  })]), _vm._v("\n      Create New\n    ")]), _vm._v(" "), _c('journey-version-list', {
    attrs: {
      "versions": _vm.versions,
      "active-version-number": _vm.activeVersionNumber
    },
    on: {
      "select": function($event) {
        return _vm.$emit('select-version', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.collapsed || _vm.peeking) ? _c('signed-in-user-panel') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0ca632b7","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/JourneySidebar.vue
// module id = /tpk
// module chunks = 1